export class Header {
  heading: string;
  icon?: string;
  queryParams: any;
  showIcon: boolean = true;
  overrideAction: boolean;
}
